import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalSidebarService } from './modal-sidebar.service';

@Component({
  selector: 'app-modal-sidebar',
  templateUrl: './modal-sidebar.component.html',
  styleUrls: ['./modal-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalSidebarComponent implements OnInit {
  show: boolean = false;
  modalData: any;

  constructor(private modalSidebarService: ModalSidebarService) {
    this.modalData = this.modalSidebarService.getModalData();
   }

  ngOnInit(): void {
    this.modalSidebarService._modalData.subscribe(
      result => {
        this.modalData = result;
      }
    )

    this.modalSidebarService._modalShow.subscribe(
      result => {
        this.show = result;
      }
    )
  }

  closeModal() {
    this.modalSidebarService.closeModal();
  }

}
